import { formatDateTimeString } from '~/cynqueModules/utils/formatDateTimeString'

declare module 'vue' {
  interface ComponentCustomProperties {
    $formatDateTimeString(value: string | null): string
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$formatDateTimeString = (
    value: string | null
  ) => {
    return formatDateTimeString(value)
    // Moved to cynqueModules/utils/formatDateTimeString.ts, so a data object can
    // call it too -- the same move the …DateOnly and …TimeOnly plugins already
    // made. The old body, and its private copy of parseISOString:
    //
    // function _parseISOString(s: string) {
    //   const b = s.split(/\D+/)
    //   return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]))
    // }

    // if (value === null) {
    //   return value
    // }

    // if (!value) {
    //   return undefined
    // }

    // return (
    //   _parseISOString(value).toISOString().substring(0, 10) +
    //   '  -  ' +
    //   _parseISOString(value).toLocaleTimeString([], {
    //     hour: '2-digit',
    //     minute: '2-digit',
    //   })
    // )
  }
})
